<template>
  <FlexColumn :space="0">
    <TextButton small class="px-0" @click="dialog=true">
      <ListCheckIcon v-if="applicant.listIds.length > 0" />
      <ListIcon v-else />
    </TextButton>
    <ApplicantListSettingDialog :open="dialog" :applicant="applicant" @close="dialog=false" />
  </FlexColumn>
</template>

<script>
import TextButton from "@/components/atoms/TextButton";
import ListIcon from "@/components/atoms/ListIcon";
import FlexColumn from "@/components/atoms/FlexColumn";
import ApplicantListSettingDialog from "@/components/organisms/ApplicantListSettingDialog";
import ListCheckIcon from "../atoms/ListCheckIcon";
export default {
  name: "ApplicantListAddButton",
  components: {ListCheckIcon, ApplicantListSettingDialog, FlexColumn, ListIcon, TextButton},
  props: {
    applicant: {
      type: Object
    }
  },
  data() {
    return {
      dialog: false
    }
  }
}
</script>

<style scoped>

</style>